export default __webpack_public_path__ + "static/media/cp_geo_cc.7375ca01.svg";